import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type StyleProps = {
    desktopJustifyContent: 'flex-start' | 'flex-end';
};

export const useSingleButtonStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
    createStyles({
        actionButton: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            [theme.breakpoints.up('sm')]: {
                marginLeft: 0,
                marginRight: 0,
            },
        },
        actionButtonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '16px',
            [theme.breakpoints.up('sm')]: {
                justifyContent: ({ desktopJustifyContent }) => desktopJustifyContent,
            },
        },
    })
);

export const useTwoButtonsStyles = makeStyles((theme: Theme) =>
    createStyles({
        actionButtonsContainer: {
            display: 'flex',
            gap: theme.spacing(2),

            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        actionButton: {
            flex: 1,
        },
        saveButtonContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-start',
        },
        closeButtonContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
    })
);
